// Ajouter ici un loader pour les pages qui prennent du temps à charger avec un css simple et efficace
import React from "react";
import "../../../src/assets/css/loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;